import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

const ToolbarIconButton = ({ title, onClick, children }) => (
  <Tooltip title={title}>
    <IconButton
      size="small"
      onClick={onClick}
      sx={{
        width: 32,
        height: 32,
        borderRadius: "8px",
        border: "1px solid",
        borderColor: "rgba(0,0,0,0.1)",
        color: "text.secondary",
        "&:hover": {
          backgroundColor: "rgba(0,0,0,0.04)",
          borderColor: "rgba(0,0,0,0.18)",
          color: "text.primary",
        },
      }}
    >
      {children}
    </IconButton>
  </Tooltip>
);

export default ToolbarIconButton;
